(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_statusDetailController', Qsched_statusDetailController);

    Qsched_statusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Qsched_status'];

    function Qsched_statusDetailController($scope, $rootScope, $stateParams, previousState, entity, Qsched_status) {
        var vm = this;

        vm.qsched_status = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:qsched_statusUpdate', function(event, result) {
            vm.qsched_status = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
